require('./RAAccordionWizardStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const RACustomAccordion = require('../RACustomAccordion/RACustomAccordion');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constants
const {
    WIZARD_POSITION_FIRST,
    WIZARD_POSITION_MIDDLE,
    WIZARD_POSITION_LAST,
    WIZARD_POSITION_SINGLE,
} = require('../../raConstants/index');

class RAAccordionWizardStep extends React.Component {
    constructor(props) {
        super(props);

        this.handleEditClick = this.handleEditClick.bind(this);
    }

    handleEditClick() {
        this.props.onEditClick(this.props.step);
    }

    buildPreviousButton() {
        if (this.props.hidePrevButton) return null;
        return (
            <div className="ra-accordion-wizard-step__first-button">
                <OKButton
                    modifier="ghost"
                    leftIcon="icon-anterior"
                    size="small"
                    onClick={this.props.onPrevClick}
                >
                    <FormattedText value="roboWizard-previous" />
                </OKButton>
            </div>
        );
    }

    buildNextButton() {
        if (this.props.hideNextButton) return null;
        return (
            <div className="ra-accordion-wizard-step__second-button">
                <OKButton
                    modifier="secondary"
                    size="small"
                    onClick={this.props.onNextClick}
                    loading={this.props.loading}
                    disabled={!this.props.valid || this.props.errorFlags}
                >
                    <FormattedText value="roboWizard-next" />
                </OKButton>
            </div>
        );
    }

    buildFinishButton() {
        if (this.props.hideNextButton) return null;
        return (
            <div className="ra-accordion-wizard-step__third-button">
                <OKButton
                    modifier="primary"
                    size="small"
                    onClick={this.props.onFinishClick}
                    loading={this.props.loading}
                    disabled={!this.props.valid || this.props.finishDisabled}
                >
                    <FormattedText value="roboWizard-confirm" />
                </OKButton>
            </div>
        );
    }

    buildButtons() {
        let previousButton;
        let nextButton;
        let finishButton;

        switch (this.props.position) {
            case WIZARD_POSITION_FIRST:
                nextButton = this.buildNextButton();
                break;
            case WIZARD_POSITION_MIDDLE:
                previousButton = this.buildPreviousButton();
                nextButton = this.buildNextButton();
                break;
            case WIZARD_POSITION_LAST:
                previousButton = this.buildPreviousButton();
                finishButton = this.buildFinishButton();
                break;
            case WIZARD_POSITION_SINGLE:
            default:
                finishButton = this.buildFinishButton();
        }

        return (
            <div className="ra-accordion-wizard-step__buttons">
                {previousButton}
                {nextButton}
                {finishButton}
            </div>
        );
    }

    render() {
        const {
            children,
            disabled,
            icon,
            active,
            title,
            valid,
            optionalTitle,
            optionalTitleClassName,
            activateOnClickOfAccordion,
        } = this.props;
        const stepDone = valid && !active;
        const accordionClass = classnames('ra-accordion-wizard-step', {
            'ra-accordion-wizard-step--active': active,
            'ra-accordion-wizard-step--disabled': disabled,
        });
        const headerTitleClass = classnames(
            'ra-accordion-wizard-step__header-title no-print-out',
            {
                'ra-accordion-wizard-step__header-title--active': active,
                'ra-accordion-wizard-step__header-title--checked': stepDone,
                'ra-accordion-wizard-step__header-title--disabled': disabled,
            },
        );
        const iconClass = classnames('ra-accordion-wizard-step__icon', {
            'ra-accordion-wizard-step__icon--active': active,
            'ra-accordion-wizard-step__icon--checked': stepDone,
            'ra-accordion-wizard-step__icon--disabled': disabled,
        });
        const bodyClass = classnames({
            'ra-accordion-wizard-step__body--active': active,
        });
        const editIconClass = classnames(
            'ra-accordion-wizard-step__icon-edit',
            'icon-s-editar',
        );
        const iconContentClass = stepDone ? 'icon-exito' : icon;
        const leftIconClass = `${iconClass} ${iconContentClass}`;
        const rightIconClass = stepDone ? editIconClass : '';
        const buttons = !stepDone ? this.buildButtons() : null;

        return (
            <RACustomAccordion
                customClassName={accordionClass}
                customTitleClassName={headerTitleClass}
                isExpanded={active || valid}
                leftIconClass={leftIconClass}
                onRightIconClick={this.handleEditClick}
                rightIconClass={rightIconClass}
                title={title}
                onClickOfAccordion={
                    !active && !disabled ? this.handleEditClick : null
                }
                activateOnClickOfAccordion={activateOnClickOfAccordion}
                optionalTitle={optionalTitle}
                optionalTitleClassName={optionalTitleClassName}
            >
                <div className={bodyClass}>
                    {children}
                    {buttons}
                </div>
            </RACustomAccordion>
        );
    }
}

RAAccordionWizardStep.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    hidePrevButton: PropTypes.bool,
    hideNextButton: PropTypes.bool,
    icon: PropTypes.string,
    loading: PropTypes.bool,
    onEditClick: PropTypes.func,
    onFinishClick: PropTypes.func,
    onNextClick: PropTypes.func,
    onPrevClick: PropTypes.func,
    position: PropTypes.string.isRequired,
    step: PropTypes.number,
    title: PropTypes.string.isRequired,
    valid: PropTypes.bool,
    finishDisabled: PropTypes.bool,
    optionalTitle: PropTypes.string,
    optionalTitleClassName: PropTypes.string,
    activateOnClickOfAccordion: PropTypes.bool,
    errorFlags: PropTypes.bool,
};

RAAccordionWizardStep.defaultProps = {
    finishDisabled: false,
    loading: false,
    optionalTitle: null,
    optionalTitleClassName: null,
};

module.exports = RAAccordionWizardStep;
